<app-feature-details-grid>
  <app-feature-list-container>
    <app-feature-list-custom-item>
      <ng-container>
        <div *ngIf="showTitleAndAction" class="title-section">
          <button
            mat-icon-button
            gtm="onOpen"
            gtmAction="Delete device dialog"
            gtmCategory="commissioning"
            [matTooltip]="'+SRC_COMMISSIONINGV2.DELETE_DEVICE_TITLE' | translate"
            [viConfirm]="{
              title:
                '+INSTALLATIONS.INSTALLATION.VICARE_THERMOSTAT.DELETE_COMPONENT.TITLE' | translate,
              content: '',
              cancelBtn: 'GENERAL.BUTTON.NO' | translate,
              confirmBtn: 'GENERAL.BUTTON.YES' | translate
            }"
            (confirm)="deleteRemoteDevice(device)"
            (cancel)="deleteRemoteDevice()"
          >
            <mat-icon iconPositionEnd>delete</mat-icon>
          </button>
        </div>
        <div class="feature-name">
          {{ device.device.modelId | moduleIdRemover }}
        </div>
        <div class="mt-[8px] flex flex-col gap-[8px]">
          <div class="feature-info">
            <span class="feature-label">{{
              '+INSTALLATIONS.INSTALLATION.VITOTROL_SERIAL.DESCRIPTION' | translate
            }}</span>
            <div
              class="text-right"
              *ngrxLet="getDeviceDescription(device.device.id) as description"
            >
              {{ description | value2: featurePropertyKey.name }}
            </div>
          </div>

          <div class="feature-info">
            <span class="feature-label">{{ '+INSTALLATIONS.SRC.DEVICE.MAC' | translate }}</span>
            <div class="feature-value text-right">
              {{ device.device.id | idPrefixRemover | serialSpacing }}
            </div>
          </div>

          <div class="feature-info">
            <span class="feature-label text-align-end">{{
              '+INSTALLATIONS.INSTALLATION.VITOTROL_LQI_STRENGTH.TITLE' | translate
            }}</span>
            <div class="text-right" *ngrxLet="getLqiFeature(device.device.id) as feature">
              <span class="feature-value">
                <ng-container
                  *ngIf="
                    feature?.properties?.strength &&
                      feature?.properties?.strength?.value < lowLqiSignalThreshold;
                    then lowSignal;
                    else stableSignal
                  "
                ></ng-container>
              </span>

              <ng-template #lowSignal>
                <span class="warning-box">
                  <mat-icon
                    matTooltip="{{
                      '+INSTALLATIONS.INSTALLATION.VITOTROL_LQI_STRENGTH.TOOLTIP' | translate
                    }}"
                    >{{ iconVariant.error }}</mat-icon
                  >
                  {{ feature | value2: featurePropertyKey.strength }}
                  {{ feature | unit: 'strength' }}
                </span>
              </ng-template>

              <ng-template #stableSignal>
                {{ feature | value2: featurePropertyKey.strength }} {{ feature | unit: 'strength' }}
              </ng-template>
            </div>
          </div>

          <div *ngIf="isVitotrol100E && (battery$ | async) as feature" class="feature-info">
            <span class="feature-label">{{
              '+INSTALLATIONS.SRC.ETRV.BATTERY_STATUS' | translate
            }}</span>
            <div class="feature-value text-right">
              {{ feature | value2: featurePropertyKey.level }}
              {{ feature | unit: featurePropertyKey.level }}
            </div>
          </div>

          <div *ngrxLet="firmware$ as firmware" class="feature-info">
            <span class="feature-label">{{
              '+VENTILATION.REMOTE_CONTROLLER.FIRMWARE_VERSION' | translate
            }}</span>
            <div class="text-right">
              {{ firmware | value2: featurePropertyKey.value }}
            </div>
          </div>

          <div *ngrxLet="targetTemperatue$ as temperature" class="feature-info">
            <span class="feature-label">{{
              '+INSTALLATIONS.SRC.ETRV.TARGET_TEMPERATURE' | translate
            }}</span>
            <div class="text-right">
              {{
                activeProgram === heatingOperatingProgramsSchema.standby
                  ? noValue
                  : (temperature | value2: featurePropertyKey.temperature) +
                    ' ' +
                    (temperature | unit: featurePropertyKey.temperature)
              }}
            </div>
          </div>

          <div *ngrxLet="temperature$ as temperature" class="feature-info">
            <span class="feature-label">{{
              '+VENTILATION.REMOTE_CONTROLLER.SENSOR_TEMPERATURE' | translate
            }}</span>
            <div class="text-right">
              {{ temperature | value2: featurePropertyKey.value }} {{ temperature | unit: 'value' }}
            </div>
          </div>

          <div *ngIf="humidity$ | async as humidity" class="feature-info">
            <span class="feature-label">{{
              '+VENTILATION.REMOTE_CONTROLLER.HUMIDITY' | translate
            }}</span>
            <div class="text-right">
              {{ humidity | value2: featurePropertyKey.value }} {{ humidity | unit: 'value' }}
            </div>
          </div>

          <div *ngrxLet="heatingRegulation$ as heatingRegulation" class="feature-info">
            <span class="feature-label">
              {{
                '+INSTALLATIONS.INSTALLATION.HEATING_ZONE.CONFIGURATION_REGULATION.TITLE'
                  | translate
              }}
            </span>
            <div class="text-right">
              {{
                heatingRegulation
                  | value2: featurePropertyKey.mode
                  | heatingConfigurationRegulationType
              }}
            </div>
          </div>
        </div>
      </ng-container>
    </app-feature-list-custom-item>
  </app-feature-list-container>
</app-feature-details-grid>
